// Fixed goal taxonomy for the public "Obiettivo" catalog filter, shared with
// the admin product editor chip picker so values always match.
export const GOALS = [
  "Massa",
  "Definizione",
  "Energia",
  "Recupero",
  "Resistenza",
  "Sonno",
  "Immunità",
  "Benessere",
];
